<mat-card class="cardWithShadow dashboard-card">
  <mat-card-content id="otherClaim" class="dashboard-card-content">
    <div class="d-flex justify-content-between">
      <div>
        <mat-card-title class="dashboard-card-title">
          {{ 'dashboard.other_claims' | translate }}
        </mat-card-title>
      </div>
      <div>
        <p class="dashboard-metric-label">{{ 'dashboard.total' | translate }}</p>
        <p class="dashboard-metric-value">{{ kpi().totalAmount | currency }}</p>
      </div>
    </div>
    <div>
      <app-other-claim-chart
        [typeSummary]="kpi().typeSummary"
        [typesApi]="claimTypes()"
        (claimTypeSelected)="onClaimTypeSelected($event)" />
    </div>
  </mat-card-content>
</mat-card>
